export default __webpack_public_path__ + "static/media/no_select.810a3e4e.png";